// =============================================================================
//  CONTEÚDO ENRIQUECIDO v2 — camadas novas para os 15 arquétipos + Coração Inteiro
//  "O Coração de Todas as Coisas" — por Magan
//
//  Este módulo ADICIONA camadas ao conteúdo existente (data/archetypeData.js),
//  que passa a ser a FONTE ÚNICA (remova a cópia embutida em HeartSeasonTest.jsx).
//  Aqui estão: a essência (uma linha), a frase-semente (mantra), a tensão dos
//  4 raízes (que faltava) e os rótulos corretos das combinações.
// =============================================================================

// Rótulos canônicos (corrige o "Guerreiro" que aparecia como "Corpo + Sentido")
export const SUBTITULOS = {
  peregrino:'Arquétipo do Tempo', guardiao:'Arquétipo do Corpo',
  amante:'Arquétipo do Afeto', alquimista:'Arquétipo do Sentido',
  visionario:'Peregrino + Alquimista', encontro:'Peregrino + Amante',
  guerreiro:'Peregrino + Guardião', curador:'Amante + Guardião',
  guardiao_sabio:'Guardião + Alquimista', poeta:'Amante + Alquimista',
  profeta:'Peregrino + Amante + Alquimista', construtor:'Peregrino + Guardião + Alquimista',
  companheiro:'Peregrino + Guardião + Amante', sabio_compassivo:'Guardião + Amante + Alquimista',
  coracao_inteiro:'Integração das quatro estações',
};

// Essência — uma linha que destila cada estação
export const ESSENCIA = {
  peregrino:'O coração como travessia: o sentido mora no caminhar, não na chegada.',
  guardiao:'O coração como abrigo: a vida floresce sobre um chão firme.',
  amante:'O coração como encontro: viver é ser tocado pelo outro.',
  alquimista:'O coração como laboratório: nada se perde, tudo se transforma.',
  visionario:'O que ainda não é já germina no agora.',
  encontro:'A força se multiplica quando a estrada é dividida.',
  guerreiro:'Há honra em permanecer de pé — e sabedoria em saber quando soltar.',
  curador:'Ferido e curador ao mesmo tempo: a presença que torna a dor suportável.',
  guardiao_sabio:'Onde a estrutura encontra o sentido, nasce a sabedoria que sustenta.',
  poeta:'Traduzir o invisível em forma: amar e compreender na mesma respiração.',
  profeta:'Pressentir o que vem e ter coragem de anunciar.',
  construtor:'Encarnar o invisível no concreto: sonhar com as mãos.',
  companheiro:'Não deixar ninguém para trás — e não se esquecer de si.',
  sabio_compassivo:'A compaixão enraizada: sentir a dor do mundo sem secar por dentro.',
  coracao_inteiro:'Todas as estações vivas e em harmonia — não chegada, mas presença.',
};

// Frase-semente (mantra) — a frase que a pessoa leva consigo
export const FRASE_SEMENTE = {
  peregrino:'Não é o destino que me faz inteiro — é a coragem de continuar.',
  guardiao:'O que eu protejo também precisa de portas.',
  amante:'Amar sem me apagar: este é o meu aprendizado.',
  alquimista:'Sinto a dor como dor, antes de transformá-la em luz.',
  visionario:'Planto hoje, com as mãos, o futuro que meus olhos já veem.',
  encontro:'Caminhar junto, sem deixar de caminhar comigo mesmo.',
  guerreiro:'Há força em resistir — e há sabedoria em soltar.',
  curador:'Quem cuida do mundo também merece ser cuidado.',
  guardiao_sabio:'Que as minhas estruturas tenham janelas.',
  poeta:'Vivo primeiro; as palavras virão depois.',
  profeta:'Falo para despertar, nunca para dominar.',
  construtor:'Construo com leveza — eu valho mais do que a minha obra.',
  companheiro:'Acompanho sem me esquecer no caminho.',
  sabio_compassivo:'A compaixão também precisa de fronteiras para durar.',
  coracao_inteiro:'Já tenho tudo em mim; resta estar presente ao que é.',
};

// Tensão que te move — AGORA também para os 4 raízes (antes só combinações tinham)
export const TENSAO_RAIZ = {
  peregrino:'Você se move para não precisar chegar. Cada nova estrada adia a pergunta: e se eu parar — e ainda assim me sentir inteiro?',
  guardiao:'Você ergue muros para não sentir o caos. Mas o mesmo muro que protege pode trancar, do lado de fora, o ar que você precisa respirar.',
  amante:'Você se entrega ao outro com tanta intensidade que, às vezes, esquece de habitar a si mesmo. Amar virou o lugar onde você desaparece.',
  alquimista:'Você transforma tão depressa que quase não sente. Mas nem toda dor precisa virar lição — algumas precisam, primeiro, apenas ser dor.',
};

// Frase-semente — VARIANTE ALTERNATIVA (varia a cada vez que a pessoa refaz o teste)
export const FRASE_SEMENTE_ALT = {
  peregrino:'Aprendo a chegar sem deixar de caminhar.',
  guardiao:'Sou raiz e abrigo — inclusive de mim mesmo.',
  amante:'Sou inteiro também quando amo.',
  alquimista:'Há ouro até na minha sombra — mas primeiro eu a sinto.',
  visionario:'O amanhã já mora no meu gesto de hoje.',
  encontro:'A estrada fica mais leve quando dividida — e ainda assim é minha.',
  guerreiro:'A minha maior coragem é saber a hora de descansar.',
  curador:'Hoje, deixo que também cuidem de mim.',
  guardiao_sabio:'A minha ordem serve à vida — nunca o contrário.',
  poeta:'Sinto por inteiro antes de dar nome.',
  profeta:'Escuto mais do que anuncio.',
  construtor:'Eu existo muito além daquilo que construo.',
  companheiro:'Caminho com você e comigo, ao mesmo tempo.',
  sabio_compassivo:'Me incluo na compaixão que ofereço.',
  coracao_inteiro:'Inteiro não é estar pronto — é estar presente.',
};

// Seletor: variante 0 = original, 1 = alternativa (com fallback se faltar uma).
export function escolherSemente(key, variante = 0) {
  const a = FRASE_SEMENTE[key];
  const b = FRASE_SEMENTE_ALT[key];
  if (!a && !b) return undefined;
  return variante === 1 ? (b || a) : (a || b);
}

export default { SUBTITULOS, ESSENCIA, FRASE_SEMENTE, FRASE_SEMENTE_ALT, TENSAO_RAIZ, escolherSemente };
